import React from 'react';
import {Alert, Button, Col, Form, FormGroup, Input, Label, Row} from "reactstrap";
import {HttpRequest} from "../../util/http";

const MFA_ChallengeContainer: React.FC = () => {
    const [error, setError] = React.useState<boolean | undefined>(undefined);
    const [submitting, setSubmitting] = React.useState<boolean>(false);
    const [smsCode, setSmsCode] = React.useState<string>('');
    const [rememberMeCookie, setRememberMeCookie] = React.useState<boolean>(false);

    return (
        <section className="blacklight">
            <Form className="card-body" onSubmit={(e) => {
                console.log('formLogin(e)');
            }}>

                {error &&
                    <Alert color="danger">
                        <section>
                            <p>SMS code verification failed.</p>
                        </section>
                    </Alert>
                }

                <FormGroup>
                    <Row>
                        <Col md={6}>
                            <FormGroup>
                                <Label>SMS Verification Code</Label>
                                <Input type="text"
                                       name="smsCode"
                                       value={smsCode}
                                       onChange={(e) => setSmsCode(e.currentTarget.value)} />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6}>
                            <div>
                                <input type="checkbox"
                                       name="remember_me"
                                       checked={rememberMeCookie}
                                       style={{opacity: 0}}
                                />
                                <label onClick={() => setRememberMeCookie(!rememberMeCookie)}>Trust this device for 30
                                    days</label>
                            </div>
                            <Button color="primary" disabled={submitting} style={{height: 'auto'}} onClick={() => {
                                setSubmitting(true);
                                const method = 'POST';
                                const data = {smsCode, rememberMeCookie};
                                HttpRequest.fetch('api/user/2fa/sms-challenge-verify', {method, data}).then((response) => {
                                    setSubmitting(false);
                                    setSmsCode('');
                                    if (response['status'] === 200) {
                                        window.location.href = `/${response['redirect']}`;
                                    } else {
                                        setError(true);
                                    }
                                });
                            }}>
                                {submitting ?
                                    <>
                                        <span>Submitting...&nbsp;</span>
                                        <i className="fas fa-fw fa-cog fa-spin"/>
                                    </>
                                    :
                                    <>
                                        <span>Submit&nbsp;</span>
                                        <i className="fas fa-fw fa-paper-plane"/>
                                    </>
                                }
                            </Button>
                        </Col>
                    </Row>
                </FormGroup>
            </Form>
            <div className="card-body pt-0 pb-0">
                <Row>
                    <Col md={6}>
                        <p>Didn't receive the SMS code?&nbsp;
                            <span className="link ml-4 align-self-center" onClick={() => {
                                const method = 'POST';
                                HttpRequest.fetch('api/user/2fa-send-code', {method}).then((response) => {
                                    setSubmitting(false);
                                });
                            }}>Send code again</span>
                        </p>
                    </Col>
                </Row>
            </div>
        </section>
    )
}

export default MFA_ChallengeContainer;